import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import {
  AddSendingDomainRequest,
  ISendingDomainResponse,
  ISendingDomainsResponse,
} from "../models/SendingDomain";
import { DefaultResponse } from "../models/system";

export const sendingDomainsQueryKey = ["sending-domains"];

export default function useSendingDomains() {
  const { get, post, del } = useApiHelper();
  const queryClient = useQueryClient();

  const sendingDomains = useQuery<ISendingDomainsResponse>({
    queryKey: sendingDomainsQueryKey,
    queryFn: () => get<ISendingDomainsResponse>("/sendingdomain"),
    staleTime: 1000 * 30,
  });

  const invalidate = () => queryClient.invalidateQueries(sendingDomainsQueryKey);

  const addSendingDomain = useMutation(
    (req: AddSendingDomainRequest) =>
      post<AddSendingDomainRequest, ISendingDomainResponse>("/sendingdomain", req),
    { onSuccess: invalidate }
  );

  const verifySendingDomain = useMutation(
    (id: string) => post<{}, ISendingDomainResponse>(`/sendingdomain/${id}/verify`, {}),
    { onSuccess: invalidate }
  );

  const removeSendingDomain = useMutation(
    (id: string) => del<DefaultResponse>(`/sendingdomain/${id}`),
    { onSuccess: invalidate }
  );

  return {
    sendingDomains,
    addSendingDomain,
    verifySendingDomain,
    removeSendingDomain,
  };
}
